import { 医薬品型, 薬効型 } from '@/type/master/item/medicine';
import { その他品型 } from '@/type/master/item/other';
import { 備蓄品型 } from '@/type/master/item/stockpile';
import {Validator} from '@/type/validation/result';
import {半角カナ禁止} from '@/type/validation/validator';

export enum 商品区分型 {
  医薬品 = '医薬品',
  その他品 = 'その他品',
  備蓄品 = '備蓄品',
}

export interface バラ管理単位選択型 {
  表示内容: string;
  選択値: string;
}

export interface 採用品型 {
  商品コード: string;
  商品区分: string;
  リビジョン番号: number;
  商品名: string;
  商品名カナ: string;
  JANコード: string;
  販売GTINコード: string;
  包装GTINコード: string;
  備蓄商品コード: string;
  バラ単位区分: string;
  包装単位数: number | null;
  包装単位名: string;
  包装数量数: number | null;
  包装数量単位名: string;
  規格容量: string;
  規格容量カナ: string;
  入数: number | null;
  メーカーコード: string;
  使用区分: string;
  メモ1: string;
  メモ2: string;
  メモ3: string;
  メモ4: string;
  メモ5: string;
  複写フラグ: string;
  発注検索対象外フラグ: string;
  採用品管理対象外フラグ: string;
  棚卸対象外フラグ: string;
  金額集計対象外フラグ: string;
  ハンディ連携対象外フラグ: string;
  入庫即移動フラグ: string;
  移動先部署コード: string;
  卸コード: string;
  適用開始日: number | null;
  価格: number | null;
  メーカー名: string;
  独自コード: string;
  独自区分: number | null;
  独自連携コード: string;
  係数: number | null;
  連携対象フラグ: string;
  機械発注区分: string;
  発注点: number | null;
  確保数: number | null;
  不動日数: number | null;
  不動日数設定対象フラグ: string;
}

export interface 採用品拡張項目型 {
  商品コード: string;
  独自連携コード: string;
  係数: number | null;
  連携対象フラグ: string;
  機械発注区分: string;
  発注点: number | null;
  確保数: number | null;
  不動日数: number | null;
  不動日数設定対象フラグ: string;
}

export interface 採用品要約型 {
  商品コード: string;
  商品区分: string;
  後発品: 後発品型 | null;
  商品名: string;
  商品名カナ: string;
  JANコード: string;
  販売GTINコード: string;
  包装GTINコード: string;
  バラ単位区分: string;
  包装単位数: number;
  包装単位名: string;
  包装数量数: number;
  包装数量単位名: string;
  規格容量: string;
  規格容量カナ: string;
  入数: number;
  メーカーコード: string | null;
  仕入先名: string;
  リビジョン番号: number;
  使用区分: string;
  採用品管理対象外フラグ: string;
  独自コード: string;
  独自区分: number | null;
  独自区分名: string;
  経過措置区分: string;
  在庫数: number;
  納入価: number;
}

export interface 初期卸型 {
  医薬品初期卸: string;
  その他品初期卸: string;
  備蓄品初期卸: string;
}

export interface 採用品管理対象外識別子型 {
  リビジョン番号: number;
}

export enum 後発品型 {
  非該当製品 = '非該当製品',
  後発品 = '後発品',
}

export interface 採用品検索条件型 {
  商品名カナ検索文字列: string;
  メーカー名カナ検索文字列: string;
  使用区分: string | null;
  商品区分: string;
  ソート区分: string;
  採用品管理対象外検索区分: string;
}

export interface 採用品登録選択型 {
  マスタ選択: string;
  商品区分: string;
}

export const 採用品初期値 = {
  商品コード: '',
  商品区分: '',
  リビジョン番号: 0,
  商品名: '',
  商品名カナ: '',
  JANコード: '',
  販売GTINコード: '',
  包装GTINコード: '',
  備蓄商品コード: '',
  バラ単位区分: '',
  包装単位数: 0,
  包装単位名: '',
  包装数量数: 0,
  包装数量単位名: '',
  規格容量: '',
  規格容量カナ: '',
  入数: 0,
  メーカーコード: '',
  使用区分: '',
  メモ1: '',
  メモ2: '',
  メモ3: '',
  メモ4: '',
  メモ5: '',
  トーショー係数: 0,
  複写フラグ: '',
  発注検索対象外フラグ: '発注対象',
  採用品管理対象外フラグ: '対象',
  棚卸対象外フラグ: '棚卸対象',
  金額集計対象外フラグ: '対象',
  ハンディ連携対象外フラグ: '対象',
  入庫即移動フラグ: '対象',
  移動先部署コード: '',
  卸コード: '',
  適用開始日: 0,
  価格: 0,
  メーカー名: '',
  独自コード: '',
  独自連携コード: '',
  係数: 1,
  連携対象フラグ: '対象外',
  機械発注区分: 'しない',
  発注点: 0,
  確保数: 1,
  不動日数: 30,
  不動日数設定対象フラグ: '対象',
};

export interface 採用品検索結果型 {
  採用品検索結果一覧: 採用品要約型[];
  アラートメッセージ: string;
}


export interface 採用品一括登録結果型 {
  商品区分: string;
  JANコード: string;
  商品名: string;
  商品名カナ: string;
  規格容量: string;
  規格容量カナ: string;
  採用品取込エラーメッセージ: string;
}

export interface 採用品包括型 {
  採用品: 採用品型;
  医薬品: 医薬品型;
  その他品: その他品型;
  備蓄品: 備蓄品型;
  薬効: 薬効型;
  在庫データ件数: number;
  在庫数: number;
}

export const 採用品検索条件型バリデータ一覧: Validator[] = [
  {
    name: 'メーカー名カナ検索文字列',
    constraints: [
      {method: 半角カナ禁止, message: 'メーカー名カナに半角カナが含まれています'},
    ],
  },
  {
    name: '商品名カナ検索文字列',
    constraints: [
      {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
    ],
  },
];
